import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-sale-payment-plan-popup',
  templateUrl: './sale-payment-plan-popup.component.html',
  styleUrls: ['./sale-payment-plan-popup.component.scss']
})
export class SalePaymentPlanPopupComponent {

  constructor(
    public dialogRef: MatDialogRef<SalePaymentPlanPopupComponent>,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
      this.props;
  }
  getPaysVal(val: string) {
    return val.split("")[0] == "." ? `0${val}` : val;
  }

}
